module.exports = __webpack_public_path__ + "img/jpg.da370502.svg";